/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { PropTypes } from 'prop-types';
import { IoClose } from 'react-icons/io5';
import Button from '../Button/Button';

const UnsavedChangesModal = ({
  handleClose = () => {}, onDiscard = () => {}, onSave = () => {},
}) => {
  return (
    <div className="fixed top-0 right-0 bg-black/50 z-50 w-screen h-screen flex items-center justify-center" onClick={handleClose}>
      <div className="w-1/3 modalWidth bg-white rounded-md relative py-10" onClick={e => e.stopPropagation()}>
        <button type="button" className="focus:outline-none right-0 absolute top-3 right-3"><IoClose onClick={handleClose} size={24} color="#676767" className="" /></button>
        <h2 className="text-xl font-normal text-center">Would you like to save your changes?</h2>
        <div className="flex space-x-4 items-center justify-center pt-8">
          <Button
            label="Discard"
            size="md"
            onClick={onDiscard}
            color="secondary"
          />
          <Button
            label="Save"
            size="md"
            onClick={onSave}
          />

        </div>
      </div>
    </div>
  );
};

UnsavedChangesModal.propTypes = {
  handleClose: PropTypes.func,
  onDiscard: PropTypes.func,
  onSave: PropTypes.func,
};

export default UnsavedChangesModal;
